import { useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { forEach } from 'lodash'

import { useLenis } from '@/contexts/lenis'

export const useGridMotion = () => {
  const motionRef = useRef<HTMLDivElement>(null)
  const { lenis } = useLenis()

  /**
   * reveal setup
   */
  useGSAP(
    () => {
      if (!lenis) return

      const scrollTrigger = ScrollTrigger.batch('[data-motion-card]', {
        start: 'top bottom',
        end: 'bottom top',
        once: true,
        onEnter: (batch) =>
          gsap.fromTo(
            batch,
            { y: 30, opacity: 0 },
            {
              y: 0,
              opacity: 1,
              duration: 0.6,
              ease: 'power3.out',
              stagger: {
                amount: 0.2
              }
            }
          )
      })

      return () => {
        forEach(scrollTrigger, (st) => st.kill())
      }
    },
    { scope: motionRef, dependencies: [lenis] }
  )

  return { motionRef }
}
